
import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { HELPDESK_AUTH_TOKEN } from '../queries/GraphQLQueries';
import { ZendeskAPI } from "../config/ZendeskConfig";

export default function useZendesk() {

    const { loading, errors, data } = useQuery(HELPDESK_AUTH_TOKEN);

    useEffect(() => {

        ZendeskAPI("messenger", "show");

        return () => {
            ZendeskAPI("messenger", "hide");
        };
    }, []);

    useEffect(() => {
        if (data) {
            ZendeskAPI("messenger", "loginUser", function (callback) {
                callback(data.helpdeskAuthToken)
            })
        }
    }, [data]);

};